<template>
    <div>
        <b-modal ref="booking" id="booking" @close="handleReset" @hide="closing" @ok.prevent="bookGame" :title="modalTitle" size="xl" centered :visible=" ! loading" ok-only ok-title="Book" :ok-disabled="loading || processing">
            <template v-if="game">
                <b-row>
                    <b-col>
                        <table class="table table-striped table-sm">
                            <thead>
                                <tr>
                                    <th>Item</th>
                                    <th>Price</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ game.title || 'Game Fee' }}</td>
                                    <td>£{{ (game.price / 100).toFixed(2) }}</td>
                                </tr>
                                <template v-if="rentals.length > 0">
                                    <tr>
                                        <td colspan="2">Rentals</td>
                                    </tr>
                                    <tr v-for="rental in rentals" :key="rental.id">
                                        <td>{{ rental.name }}</td>
                                        <td>£{{ (rental.price / 100).toFixed(2) }}</td>
                                    </tr>
                                </template>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colspan="2" class="text-right">Total £{{ (totalPrice / 100).toFixed(2) }}</td>
                                </tr>
                            </tfoot>
                        </table>
                    </b-col>
                    <b-col>
                        <h5>Rentals</h5>
                        <b-button v-for="rentalType in rentalTypes" v-if="checkRental(rentalType)" :key="rentalType.id" @click="choose(rentalType)" :variant="(chosen(rentalType)) ? 'outline-primary' : 'primary'" type="button" block>{{ rentalType.name }} £{{ (rentalType.price / 100).toFixed(2) }}</b-button>
                    </b-col>
                </b-row>
            </template>

            <template v-if="processingStage" #modal-footer>
                <small class="text-muted">{{ processingStage }}</small>
            </template>
        </b-modal>
    </div>
</template>

<script>
import moment from 'moment-timezone';

export default {
    props: {
        gameId: {
            default: false,
        },
        memberId: {
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            processing: false,
            rentalTypes: [],
            game: false,
            rentals: [],
            booking: {
                game_id: false,
                member_id: this.memberId,
                price: false,
                state: 'pending',
            },
            processingStage: false,
        }
    },
    computed: {
        modalTitle() {
            return this.game ? (this.game.title) ? this.game.title + ' ' + this.gameDate : this.gameDate : 'Game Booking';
        },
        gameDate() {
            if ( ! this.game) {
                return '';
            }
            return moment(this.game.start_time).tz('Europe/London').format('ddd Do MMM YYYY HH:mm');
        },
        totalPrice() {
            let total = this.game.price;
            this.rentals.forEach((rental) => {
                total += rental.price;
            });
            return total;
        },
    },
    methods: {
        bookGame(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.processing = true;
            this.processingStage = 'Creating booking...';
            this.booking.state = 'booked';

            axios.post(this.$routes.route('bookings.store'), this.booking)
                .then((response) => {
                    this.processingStage = 'Booking created.';
                    this.booking = response.data;
                    if (this.rentals.length > 0) {
                        this.processingStage += ' Booking rentals...';

                        this.bookRentals();
                        this.sendBookingEmail();

                        this.processingStage = 'Rentals booked.';

                        this.processingStage = 'Booking complete.';
                        this.processing = false;
                        setTimeout(() => {
                            this.handleReset();
                        }, 3000);
                    } else {
                        this.sendBookingEmail();
                        this.processingStage = 'Booking complete.';
                        this.processing = false;
                        setTimeout(() => {
                            this.handleReset();
                        }, 3000);
                    }
                })
                .catch((error) => {});
        },
        bookRentals() {
            this.rentals.forEach((ren) => {
                let rental = {
                    booking_id: this.booking.id,
                    rental_type_id: ren.id,
                };

                axios.post(this.$routes.route('bookings.addRental'), rental)
                    .then((response) => {})
                    .catch((error) => {});
            });
        },
        sendBookingEmail() {
            axios.get(this.$routes.route('bookings.sendEmail', {booking: this.booking.id}))
                .then((response) => {
                    this.processingStage = 'Booking email sent';
                    return;
                })
                .catch((error) => {
                    this.processingStage = 'Booking email failed to send';
                    return;
                });
        },
        addRental(rental) {
            this.rentals.push(rental);
        },
        removeRental(rental) {
            this.rentals = this.rentals.filter((r) => r.id !== rental.id);
        },
        checkRental(rentalType) {
            return this.game.rentalLimits[rentalType.id] > 0 || rentalType.unlimited;
        },
        choose(item) {
            if (this.rentals.indexOf(item) === -1) {
                this.addRental(item);
            } else {
                this.removeRental(item);
            }
        },
        chosen(item) {
            return this.rentals.indexOf(item) !== -1;
        },
        closing() {
            // this.$emit('closing');
            // this.game = false;
            // this.rentalTypes = [];
            // this.booking.price = false;
            // this.booking.game_id = false;
        },
        handleReset() {
            console.log('reset');
            this.game = false;
            this.rentalTypes = [];
            this.booking.price = false;
            this.booking.game_id = false;
            this.$emit('closing');
        },
        init() {
            axios.get(this.$routes.route('bookings.rentalTypes'))
                .then((response) => {
                    this.rentalTypes = response.data;
                })
                .catch((error) => {});

            axios.get(this.$routes.route('bookings.game', {game: this.gameId}))
                .then((response) => {
                    this.game = response.data;
                    this.booking.price = this.game.price;
                    this.booking.game_id = this.game.id;
                    this.loading = false;
                })
                .catch((error) => {});
        },
    },
    mounted() {
        this.loading = true;
        this.init();
    },
}
</script>